var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('feature-screen', {
    attrs: {
      "image": "/views/press/downloads/spoferan-presse-multimedia-foto-video-download-bereich.jpg",
      "lang-prefix": "view.downloads.index"
    }
  }, [_c('template', {
    slot: "cta"
  }, [_c('btn', {
    attrs: {
      "large": "",
      "to": _vm.$web('index'),
      "exact": ""
    }
  }, [_c('icon', {
    attrs: {
      "icon": _vm.$icons.back
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('action.to_overview')))])], 1), _vm._v(" "), _c('btn', {
    attrs: {
      "color": "primary",
      "to": _vm.$spoferan('contact'),
      "large": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('action.contact_us')))])])], 1)], 2), _vm._v(" "), _c('page-content', [_c('feature-section', {
    attrs: {
      "breakpoint": "sm",
      "title": _vm.$t('view.downloads.index.photos.title'),
      "description": _vm.$t('view.downloads.index.photos.content'),
      "cols": "8"
    }
  }, [_c('btn', {
    attrs: {
      "slot": "cta",
      "to": _vm.$web('downloads.photos.index'),
      "color": "primary",
      "large": ""
    },
    slot: "cta"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('view.downloads.index.photos.action')))]), _vm._v(" "), _c('icon', {
    attrs: {
      "icon": _vm.$icons.next
    }
  })], 1), _vm._v(" "), _c('card', {
    attrs: {
      "to": _vm.$web('downloads.photos.index'),
      "no-spacing": "",
      "no-tile": "",
      "width": "280"
    }
  }, [_c('card-image', {
    attrs: {
      "src": "/views/press/downloads/spoferan-300-dpi-fotos-fuer-bildschirm-web-uebersicht.jpg",
      "alt": _vm.$t('view.downloads.index.photos.title'),
      "size": {
        width: 280,
        ratio: 3 / 2
      }
    }
  })], 1)], 1), _vm._v(" "), _c('feature-section', {
    attrs: {
      "breakpoint": "sm",
      "title": _vm.$t('view.downloads.index.videos.title'),
      "description": _vm.$t('view.downloads.index.videos.content'),
      "cols": "8"
    }
  }, [_c('btn', {
    attrs: {
      "slot": "cta",
      "to": _vm.$web('downloads.videos.index'),
      "color": "primary",
      "large": ""
    },
    slot: "cta"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('view.downloads.index.videos.action')))]), _vm._v(" "), _c('icon', {
    attrs: {
      "icon": _vm.$icons.next
    }
  })], 1), _vm._v(" "), _c('card', {
    attrs: {
      "to": _vm.$web('downloads.videos.index'),
      "no-spacing": "",
      "no-tile": "",
      "width": "280"
    }
  }, [_c('card-image', {
    attrs: {
      "src": "/views/press/downloads/spoferan-video-download-uebersicht.jpg",
      "alt": _vm.$t('view.downloads.index.videos.title'),
      "size": {
        width: 280,
        ratio: 3 / 2
      }
    }
  })], 1)], 1), _vm._v(" "), _c('feature-section', {
    attrs: {
      "breakpoint": "sm",
      "title": _vm.$t('view.downloads.index.audios.title'),
      "description": _vm.$t('view.downloads.index.audios.content'),
      "cols": "8",
      "divided": false
    }
  }, [_c('btn', {
    attrs: {
      "slot": "cta",
      "to": _vm.$web('downloads.audios.index'),
      "color": "primary",
      "large": ""
    },
    slot: "cta"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('view.downloads.index.audios.action')))]), _vm._v(" "), _c('icon', {
    attrs: {
      "icon": _vm.$icons.next
    }
  })], 1), _vm._v(" "), _c('card', {
    attrs: {
      "to": _vm.$web('downloads.audios.index'),
      "no-spacing": "",
      "no-tile": "",
      "width": "280"
    }
  }, [_c('card-image', {
    attrs: {
      "src": "/views/press/downloads/spoferan-audio-download-uebersicht.jpg",
      "alt": _vm.$t('view.downloads.index.audios.title'),
      "size": {
        width: 280,
        ratio: 3 / 2
      }
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }